const API_URL = process.env.REACT_APP_API_HOST;
const AUTH_URL = process.env.REACT_APP_AUTH_HOST;

export { API_URL, AUTH_URL };
